export const TOKEN_VALIDATION_ERROR = {
  TOKEN_EXPIRED: 'token_expired',
  INVALID_TOKEN: 'invalid_token',
  REQUEST_TIMEOUT: 'request_timeout',
  NETWORK_ERROR: 'network_error',
};

export function isRetryableTokenValidationError(type) {
  return type === TOKEN_VALIDATION_ERROR.REQUEST_TIMEOUT
    || type === TOKEN_VALIDATION_ERROR.NETWORK_ERROR;
}

export function isCanceledRequest(error) {
  return error?.code === 'ERR_CANCELED'
    || error?.name === 'CanceledError'
    || error?.config?.signal?.aborted === true;
}

function hasExpiredServerMessage(error) {
  const message = error?.response?.data?.message;
  return typeof message === 'string' && message.includes('expired');
}

function isTransportFailure(error) {
  if (error?.response) {
    return false;
  }

  return Boolean(
    error?.isAxiosError
    || error?.code === 'ERR_NETWORK'
    || error?.message === 'Network Error'
  );
}

export function getTokenValidationErrorType(error) {
  if (isCanceledRequest(error)) {
    return null;
  }

  if (error?.code === 'ECONNABORTED') {
    return TOKEN_VALIDATION_ERROR.REQUEST_TIMEOUT;
  }

  if (hasExpiredServerMessage(error)) {
    return TOKEN_VALIDATION_ERROR.TOKEN_EXPIRED;
  }

  if (isTransportFailure(error)) {
    return TOKEN_VALIDATION_ERROR.NETWORK_ERROR;
  }

  const status = error?.response?.status;
  if (status === 429 || status >= 500) {
    return TOKEN_VALIDATION_ERROR.NETWORK_ERROR;
  }

  return TOKEN_VALIDATION_ERROR.INVALID_TOKEN;
}
